<template>
    <div class="container">
        <div style="font-size: 14px; margin-top: 15px;">镜像ID：{{currentMirror.id}}</div>
        <div style="font-size: 14px; margin-top: 15px;">镜像备注：{{currentMirror.remark}}</div>
        <div style="font-size: 14px; margin-top: 15px;">生成时间：{{currentMirror.createTime | formatDateTime}}</div>
        <div class="device-case border-all">
            <el-table ref="multipleTable" :max-height="tableHeight" :data="mirrorOperationList"
                      :header-cell-style="{backgroundColor: '#efefef'}" size="mini" strip
                      tooltip-effect="dark" style="width: 99%;">
                <el-table-column
                        prop="createTime"
                        label="时间"
                >
                    <template slot-scope="scope">
                        {{scope.row.createTime | formatDateTime}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="deviceIpInuse"
                        label="操作云机IP"
                >
                </el-table-column>
                <el-table-column
                        label="操作类型"
                >
                    <template slot-scope="scope">
                        {{ scope.row.operationType === 1 ? '保存' : '切换' }}
                    </template>
                </el-table-column>
                <el-table-column
                        label="状态"
                >
                    <template slot-scope="scope">
                        {{ scope.row.operationStatus | operationStatusStr}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="deviceMirrorSize"
                        label="镜像容量"
                >
                    <template slot-scope="scope">
                        {{ scope.row.deviceMirrorSize + "MB"}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="新增文件数量"
                >
                    <template slot-scope="scope" v-if="scope.row.addFileNum >= 0">
                        {{ scope.row.addFileNum + (scope.row.operationType === 1 ? " (上传)" : " (下载)") }}
                    </template>
                </el-table-column>
                <el-table-column
                        label="删除文件数量"
                >
                    <template slot-scope="scope" v-if="scope.row.subFileNum >= 0">
                        {{ scope.row.subFileNum + (scope.row.operationType === 1 ? " (服务器)" : " (云机)") }}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="id"
                        label="镜像标识符"
                >
                </el-table-column>
                <el-table-column label="操作" >
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click.stop="downloadLogFile(scope.row.id)">下载日志
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="list-bottom">
                <div>
                </div>
                <el-pagination
                        @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle"
                        :current-page="page.startPage"
                        :page-sizes="[10, 20, 50]"
                        :page-size="page.limit"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next"
                        :total="info.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "MirrorRecord",
        data() {
            return {
                tableHeight: 0,
                info: {
                    success: false,
                    list: [],
                    total: 0
                },
                mirrorOperationList: [],
                page: { // 分页参数
                    startPage: 1,
                    limit: 10
                },
                currentMirror: {
                    id: '',
                    deviceIpUpload: '',
                    deviceIpInuse: '',
                    remark: '',
                    workStatus: 0,
                    operationStatus: 0,
                    createTime: '',
                    updateTime: '',
                    deviceMirrorSize: 0,
                    addFileNum: 0,
                    subFileNum: 0
                },
            }
        },
        filters: {
            operationStatusStr(status) {
                switch (status) {
                    case 0:
                        return '准备中'
                    case 1:
                        return '保存中'
                    case 2:
                        return '保存失败'
                    case 3:
                        return '上传中'
                    case 4:
                        return '上传失败'
                    case 5:
                        return '上传成功'
                    case 10:
                        return '下载中'
                    case 11:
                        return '下载失败'
                    case 12:
                        return '切换中'
                    case 13:
                        return '切换失败'
                    case 14:
                        return '切换成功'
                    case 20:
                        return '命令发送失败'
                }
            }
        },
        computed: {},
        methods: {
            downloadLogFile(id) {
                let formData = new FormData()
                formData.append("operationId", id)
                axios.post(this.$uri.deviceMirror.downloadLog, formData, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        ...this.$store.state.userInfo,
                        userId: this.$store.state.userInfo.id,
                        Accept: 'application/octet-stream'
                    },
                    responseType:'blob'
                    }
                ).then(function(res) {
                    // console.log(res)
                    var blob = new Blob([res.data], {type: res.headers['content-type']});
                    // console.log(blob)
                    var contentDisposition = res.headers['content-disposition'];  //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
                    var patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
                    var result = patt.exec(contentDisposition);
                    var filename = result[1];
                    var downloadElement = document.createElement('a');
                    var href = window.URL.createObjectURL(blob); //创建下载的链接
                    downloadElement.style.display = 'none';
                    downloadElement.href = href;
                    downloadElement.download = filename ; //下载后文件名
                    document.body.appendChild(downloadElement);
                    downloadElement.click(); //点击下载
                    document.body.removeChild(downloadElement); //下载完成移除元素
                    window.URL.revokeObjectURL(href); //释放掉blob对象
                })
            },
            formatTime(val) {
                var date = new Date(val)
                let str = date.getFullYear()
                let mon = date.getMonth() + 1
                str += "-"
                str += (mon > 9) ? mon.toString() : "0" + mon
                str += "-"
                str += (date.getDate() > 9) ? date.getDate().toString() : "0" + date.getDate()
                str += " "
                str += (date.getHours() > 9) ? date.getHours().toString() : "0" + date.getHours()
                str += ":"
                str += (date.getMinutes() > 9) ? date.getMinutes().toString() : "0" + date.getMinutes()
                str += ":"
                str += (date.getSeconds() > 9) ? date.getSeconds().toString() : "0" + date.getSeconds()
                return str
            },
            getMirrorOperationList() {
                let id = this.currentMirror.id
                this.$post(this.$uri.deviceMirror.listOperation, {deviceMirrorId: id})
                    .then(res => {
                        if (res.success) {
                            console.log("res is " + JSON.stringify(res))
                            this.info = res
                            if (res.total > 0) {
                                this.mirrorOperationList = res.list
                            }
                        }
                    })
            }
            ,
            /* 当前页改变 */
            currentChangeHandle(val) {
                this.page.startPage = val
                this.getMirrorOperationList()
            },
            /* 每页条数改变 */
            sizeChangeHandle(val) {
                this.page.limit = val
                this.getMirrorOperationList()
            },

        },
        mounted() {
            this.currentMirror = JSON.parse(JSON.stringify(this.$store.state.mirrorRecord))
            this.getMirrorOperationList()
            this.$nextTick().then(() => {
                this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
            })
        }
    };
</script>

<style lang="less" scoped>
    .container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
        height: 100%;
    }

    .device-case {
        width: 100%;
        /*background-color: red;*/
        margin-top: 10px;
        .list-bottom {
            padding: 10px 8px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            .list-bottom-btn {
                display: flex;
                flex-direction: row;
            }
        }
    }
</style>